import React, { useEffect, useRef, useState } from 'react';
import { Grid, Box, Hidden, Button } from '@material-ui/core';
import musafirbazarlogo from '../../assets/images/musafirbazarlogo.png';
import Typed from 'typed.js';
import facebook from '../../assets/images/facebook.png';
import twitter from '../../assets/images/twitter.png';
import google from '../../assets/images/google.png';
import header from '../../assets/images/header-bg.jpg';
import './Homepage2.css';
import TitleText from '../../components/reusableComponents/TitleText';
import { useDispatch } from 'react-redux';
import { fetchBannerDispatch } from '../../reducers/BannerReducer';
import { fetchCityDispatch } from '../../reducers/HomeReducer';
import OurServiceSection from '../../components/reusableComponents/OurServiceSection';
import './Agents.css';
import { useHistory } from 'react-router-dom';
import {
	travellerloginDispatch,
	agentSignupDispatch,
	agentloginDispatch,
} from '../../reducers/UserReducer';
import SuccessModal from '../../components/reusableComponents/SuccessModal';
import ErrorModal from '../../components/reusableComponents/ErrorModal';
const dataService = [
	{
		id: 1,
		title: 'Affordable Hotels Booking',
		fontawesomeIcon: 'fas fa-hotel',
		desc: 'We offer the easiest hotel reservation services for you to take advantage of. Avail the best prices and check out accurate hotel listings in India and abroad',
	},
	{
		id: 2,
		title: 'Fastest Travel Booking',
		fontawesomeIcon: 'fas fa-plane',
		desc: 'Book Your Flight And Train Tickets Online Without Going Through Any Hassle. Check Availability Of Seats, Schedule And Compare Fares For Both Domestic As Well As Foreign Travel.',
	},
	{
		id: 3,
		title: 'Bus Booking',
		fontawesomeIcon: 'fas fa-bus',
		desc: 'A bus reservation system is a mobile or web software solution designed to provide customers with a personalized easy-to-utilize user experience for booking and purchasing tickets online.',
	},

	{
		id: 4,
		title: 'Car Booking',
		fontawesomeIcon: 'fas fa-car',
		desc: 'Our car rental system is a web-based booking system intended to meet the particular needs of car rental organizations, travel consolidators, and travel agents.',
	},
	{
		id: 5,
		title: 'new adventures',
		fontawesomeIcon: 'fas fa-hiking',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
	{
		id: 6,
		title: 'Holiday Package',
		fontawesomeIcon: 'fas fa-globe',
		desc: 'Tour Packages are one of the best ways to travel hassle-free. With seamless planning, arrangements, and transfers being taken care of, booking tour packages from india is the best way to explore the world’s varied landscapes.',
	},
];
const Agents = () => {
	const [user, setUser] = useState({
		username: '',
		password: '',
	});
	const { username, password } = user;
	const dispatch = useDispatch();
	const history = useHistory();
	// let spantyped = new Typed('#spanID', {
	// 	strings: ['Welcome to Musafirbazar for B2B!'],
	// 	typeSpeed: 100,
	// 	backSpeed: 100,
	// 	loop: true,
	// });
	const el = React.useRef(null);
	// Create reference to store the Typed instance itself
	const typed = React.useRef(null);
	React.useEffect(() => {
		const options = {
			strings: [
				'Welcome to Musafirbazar for Agent Login',
				// 'Some <strong>strings</strong> are bold',
				// 'HTML characters &times; &copy;',
			],
			typeSpeed: 100,
			backSpeed: 100,
			loop: true,
		};

		// elRef refers to the <span> rendered below
		typed.current = new Typed(el.current, options);

		// return () => {
		// 	// Make sure to destroy Typed instance during cleanup
		// 	// to prevent memory leaks
		// 	typed.current.destroy();
		// };
	}, []);
	const onInputChange = (e) => {
		setUser({ ...user, [e.target.name]: e.target.value });
	};
	const onSubmit = async (e) => {
		e.preventDefault();
		var dat = user;
		var formData = JSON.stringify(dat);
		console.log(formData);
		// dispatch(travellerloginDispatch(formData, history));
		dispatch(agentloginDispatch(formData, history));
	};
	// useEffect(() => {
	// 	dispatch(fetchBannerDispatch());
	// 	dispatch(fetchCityDispatch());
	// }, []);
	return (
		<>
			<nav className='navbar' style={{ background: 'white' }}>
				<div className='container flex'>
					<div
						onClick={() => history.push('/')}
						className='site-brand'
						style={{ cursor: 'pointer' }}>
						<img
							src={musafirbazarlogo}
							style={{ width: 300, display: 'block' }}></img>
					</div>

					<Hidden only={['xs']}>
						<Box display='flex' alignItems='center'>
							<TitleText textStyle={{ fontSize: 26, color: 'red' }}>
								Agent Helpline{' '}
							</TitleText>
							<TitleText
								textStyle={{
									fontSize: 20,
									color: 'red',
									fontWeight: 'revert',
									marginLeft: 10,
								}}>
								+91 9798779484
							</TitleText>
						</Box>
					</Hidden>
				</div>
			</nav>
			<section
				style={{
					backgroundImage: `url(${header})`,
					paddingTop: '7rem',
					position: 'relative',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					// backgroundPosition: '1px -461px',
				}}>
				<Grid container>
					<Grid
						item
						xs={12}
						md={6}
						style={{ alignSelf: 'center', textAlign: 'center' }}>
						<div className='header-title'>
							<h1
								ref={el}
								style={{
									fontSize: '3em',
									margin: '0.67em 0',
									textAlign: 'center',
									color: 'white',
								}}></h1>
							<p style={{ fontSize: '14px', color: 'white' }}>
								Lorem ipsum dolor sit amet consectetur adipisicing elit. Natus
								rerum maxime enim odit illum in molestias beatae doloremque,
								ratione optio.
							</p>
							<Button
								onClick={() => history.push('/agentsignup')}
								className='form-control'
								style={{
									background: 'rgb(239, 51, 57)',
									color: 'white',
									fontSize: '24px',
									borderRadius: '14px',
									marginTop: 20,
								}}>
								Register
							</Button>
						</div>
					</Grid>
					<Grid item xs={12} md={6}>
						<div className='form-box'>
							<h2 style={{ fontSize: 26 }}>Login Here</h2>
							<form onSubmit={(e) => onSubmit(e)}>
								<div className='input-group'>
									<label>Username</label>
									<input
										type='email'
										name='username'
										value={username}
										onChange={(e) => onInputChange(e)}
									/>
								</div>
								<div className='input-group'>
									<label>Password</label>
									<input
										type='password'
										name='password'
										value={password}
										onChange={(e) => onInputChange(e)}
									/>
								</div>
								<div style={{ textAlign: 'end', cursor: 'pointer' }}>
									<span>
										<u>Forgot Password</u>
									</span>
								</div>
								<button type='submit'>Submit &#10132;</button>
							</form>
							<p>Login in with social media account</p>
							<div className='social'>
								<img src={facebook} />
								<img src={twitter} />
								<img src={google} />
							</div>
						</div>
					</Grid>
				</Grid>
			</section>
			<section className='services' id='services'>
				<h1 className='heading'>
					{' '}
					Our <span>services</span>{' '}
				</h1>

				<div className='box-container'>
					{dataService.map((item, index) => {
						return <OurServiceSection item={item} index={index} />;
					})}
				</div>
			</section>
			<footer className='py-4'>
				<div className='container footer-row'>
					<div className='footer-item'>
						<h2>Musafir Bazar</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Company Info
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Company Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Privacy Policy
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Terms & Conditions
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									About Us
								</a>
							</li>
							<li style={{ marginTop: 5 }}>
								<a href='#' style={{ fontSize: 16 }}>
									Cancellation/ Refund Policy
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Follow us on: </h2>
						<ul className='social-links'>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.facebook.com/musafirbazaar'
									target='_blank'>
									<i className='fab fa-facebook-f'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://www.instagram.com/musafirbazar/'
									target='_blank'>
									<i className='fab fa-instagram'></i>
								</a>
							</li>
							<li>
								<a
									style={{ fontSize: 22 }}
									href='https://twitter.com/musafirbazar'
									target='_blank'>
									<i className='fab fa-twitter'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-pinterest'></i>
								</a>
							</li>
							<li>
								<a style={{ fontSize: 22 }} href='#'>
									<i className='fab fa-google-plus'></i>
								</a>
							</li>
						</ul>
					</div>

					<div className='footer-item'>
						<h2>Products</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Flight Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Bus Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Car Booking
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Holiday Package
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									Hotel Booking
								</a>
							</li>
						</ul>
					</div>
					<div className='footer-item'>
						<h2>Contact Info</h2>
						<ul>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									+91 8877773388
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									sales@musafirbazaar.com
								</a>
							</li>
							<li>
								<a href='#' style={{ fontSize: 16 }}>
									1st Floor,New Tech Grand, Bank More, Dhanbad-826001
								</a>
							</li>
						</ul>
					</div>
					{/* <div className='subscribe-form footer-item'>
						<h2>Subscribe for Newsletter!</h2>
						<form className='flex'>
							<input
								type='email'
								placeholder='Enter Email'
								className='form-control'
							/>
							<input type='submit' className='btn' value='Subscribe' />
						</form>
					</div> */}
				</div>
			</footer>
			<SuccessModal />
			<ErrorModal />
		</>
	);
};

export default Agents;
